import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  TextField,
  Button,
  Typography,
  MenuItem,
} from "@mui/material";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const Feedback = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    category: "issue",
    message: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.message.trim()) {
      alert("Please tell us a bit more about your feedback.");
      return;
    }

    try {
      setSubmitting(true);

      await addDoc(collection(db, "contactMessages"), {
        name: formData.name || null,
        email: formData.email || null,
        subject: `Feedback: ${formData.category}`,
        message: formData.message,
        type: "feedback",          // 🟢 mark as feedback
        resolved: false,
        timestamp: serverTimestamp(),
        source: "feedbackPage",    // optional, handy in Admin
      });

      alert("✅ Thank you! Your feedback has been sent.");
      setFormData({
        name: "",
        email: "",
        category: "issue",
        message: "",
      });
    } catch (error) {
      console.error("Error sending feedback:", error);
      alert("❌ Something went wrong sending your feedback. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      style={{
        backgroundImage: `url(${require("../assets/images/landing_background.jpg")})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        fontFamily: "Montserrat, sans-serif",
        color: "white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      {/* Header (same style as Contact/Help) */}
      <header
        style={{
          width: "100%",
          padding: "10px 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.5)",
        }}
      >
        <img
          src={require("../assets/images/logo_name.PNG")}
          alt="YourStoryWorld Logo"
          style={{
            height: "40px",
            cursor: "pointer",
          }}
          onClick={() => navigate("/")}
        />
        <div>
          <Button color="inherit" onClick={() => navigate("/")}>
            Home
          </Button>
          <Button color="inherit" onClick={() => navigate("/login")}>
            Sign In
          </Button>
          <Button color="inherit" onClick={() => navigate("/help")}>
            Help
          </Button>
        </div>
      </header>

      {/* Main content */}
      <main
        style={{
          background: "rgba(255, 255, 255, 0.95)",
          padding: "40px 24px",
          borderRadius: "10px",
          maxWidth: "800px",
          margin: "20px auto",
          color: "#333",
        }}
      >
        <Typography
          variant="h4"
          gutterBottom
          sx={{ color: "#007BFF", fontWeight: "bold" }}
        >
          📝 Feedback & Issues
        </Typography>
        <Typography variant="body1" paragraph>
          Help us make YourStoryWorld better! Tell us if something isn’t working,
          share an idea, or let us know what you and your children love.
        </Typography>

        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column", gap: "20px" }}
        >
          <TextField
            label="Name (optional)"
            name="name"
            value={formData.name}
            onChange={handleChange}
            fullWidth
          />

          <TextField
            label="Email (optional, for follow-up)"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            fullWidth
          />

          <TextField
            select
            label="What is this about?"
            name="category"
            value={formData.category}
            onChange={handleChange}
            fullWidth
          >
            <MenuItem value="issue">Something is not working</MenuItem>
            <MenuItem value="idea">I have a feature idea</MenuItem>
            <MenuItem value="content">Story / content feedback</MenuItem>
            <MenuItem value="other">Something else</MenuItem>
          </TextField>

          <TextField
            label="Describe the issue or feedback"
            name="message"
            value={formData.message}
            onChange={handleChange}
            fullWidth
            multiline
            rows={5}
            required
          />

          <Button
            variant="contained"
            type="submit"
            disabled={submitting}
            sx={{
              backgroundColor: "#007BFF",
              color: "white",
              fontWeight: "bold",
              paddingY: "10px",
            }}
          >
            {submitting ? "Sending..." : "Submit Feedback"}
          </Button>
        </form>
      </main>

      {/* Footer */}
      <footer
        style={{
          textAlign: "center",
          padding: "20px",
          backgroundColor: "#000",
          color: "#fff",
        }}
      >
        <Typography>
          &copy; {new Date().getFullYear()} YourStoryWorld | All Rights Reserved
        </Typography>
        <Typography variant="body2">
          <a href="/about" style={{ color: "white", textDecoration: "none" }}>
            About Us
          </a>{" "}
          |{" "}
          <a href="/contact" style={{ color: "white", textDecoration: "none" }}>
            Contact
          </a>{" "}
          |{" "}
          <a href="/feedback" style={{ color: "white", textDecoration: "none" }}>
            Feedback
          </a>
        </Typography>

        <Typography
          variant="caption"
          style={{ marginTop: "10px", display: "block", color: "#ccc" }}
        >
          ⚠️ Disclaimer: The stories generated by YourStoryWorld are created using AI
          and are intended for entertainment and educational purposes only. While we
          strive for accuracy, some content may contain factual or narrative
          inconsistencies.
        </Typography>
      </footer>
    </div>
  );
};

export default Feedback;

